import { FormBuilder, FormGroup } from '@angular/forms';

import { inject } from '@angular/core';

export class BaseFiltroComponent {
	form!: FormGroup;
	submetido = false;

	protected readonly fb = inject(FormBuilder);

	protected desabilitarCampos(campos: string[]) {
		campos.forEach(campo => {
			this.form.get(campo)?.disable();
		});
	}

	protected habilitarCampos(campos: string[]) {
		campos.forEach(campo => {
			this.form.get(campo)?.enable();
		});
	}

	protected resetCampos(campos: string[]) {
		campos.forEach(campo => {
			this.form.get(campo)?.reset();
		});
	}
}
